/**
 * NOTE: labor-core パッケージ一覧の query 窓口（デモ用 YEA mock 委譲を含む）。
 * mock id はデモ fixtures、それ以外（実 id）は実 API へ委譲する hybrid 層
 * （`yearEndAdjustmentMockApi`）に委譲する。デモ運用が不要になったら委譲を外して
 * `@/features/operation-packages` の実 API のみを利用する。
 */
import { startPattern as assignTaskToPersonApi } from '@/features/operation-packages/api';
import type { StartPatternResponse } from '@/features/operation-packages/api';
import { usePostOperationPackagePatterns as usePostOperationPackagePatternsCommon } from '@/features/operation-packages/hooks';
import type { MockYearEndAdjustmentOperationPackage } from '../-mock/yearEndAdjustmentFixtures';
import { useGetOperationPackageInstances as useGetOperationPackageInstancesMock } from './useGetOperationPackageInstancesMock';
import { getOperationPackageCountInProgress, getOperationPackagePatterns, getOperationPackages, useGetGovernmentApplicationPackageInstances as useGetGovernmentApplicationPackageInstancesMock, useGetOperationPackagePatterns as useGetOperationPackagePatternsMock, useGetOperationPackages as useGetOperationPackagesMock, useGetOperationTaskCountInProgress as useGetOperationTaskCountInProgressMock, type MockOperationPackagesResponse } from './yearEndAdjustmentMockApi';
const OWNER_PRODUCT = 'HRF_LABOR_CORE';

// --- API Wrappers (for usage outside hooks if needed) ---

export type GetOperationPackagesRes = MockOperationPackagesResponse;
export type { MockYearEndAdjustmentOperationPackage };
export { getOperationPackages };
export { getOperationPackageCountInProgress };
export { getOperationPackagePatterns };
export const assignTaskToPerson = (id: string, patternId: string, body: {
  targetPersonIds: string[];
  anchorDate: string;
  tagName?: string;
}): Promise<StartPatternResponse> => assignTaskToPersonApi(OWNER_PRODUCT, id, patternId, body);

// --- Hooks Wrappers ---

export const useGetOperationPackages = () => useGetOperationPackagesMock(OWNER_PRODUCT);
export const useGetOperationPackagePatterns = (id: string, options?: {
  enabled?: boolean;
}) => useGetOperationPackagePatternsMock(OWNER_PRODUCT, id, options);
export const usePostOperationPackagePatterns = (id: string, options?: {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}) => usePostOperationPackagePatternsCommon(OWNER_PRODUCT, id, options);
export const useGetOperationTaskCountInProgress = (params: {
  operationPackageId: string;
  patternId: string;
}) => useGetOperationTaskCountInProgressMock({
  ownerProduct: OWNER_PRODUCT,
  ...params
});
export const useGetOperationPackageInstances = (patternId: string, options?: {
  enabled?: boolean;
  page?: number;
  pageSize?: number;
  targetId?: string;
}) => useGetOperationPackageInstancesMock(OWNER_PRODUCT, patternId, options);
export const useGetGovernmentApplicationPackageInstances = (patternId: string, options?: {
  enabled?: boolean;
  page?: number;
  pageSize?: number;
  targetId?: string;
}) => useGetGovernmentApplicationPackageInstancesMock(OWNER_PRODUCT, patternId, options);